<button class="sliderDs__cont" aria-label="sliderDs">
  <div #sliderDsRange></div>
</button>